import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import getTBWStore from "../../../stores/developer-store/tbw-store";
import { TCorePage, TTBWExtraData } from "../../../Types";
import Et3Button from "../../et3-button";

const WarningButton = withLiteObserverAndTheme<{
  extraData: TTBWExtraData;
  fromPage: TCorePage;
  style: {};
  disabled: boolean;
  size: "DEFAULT" | "MEDIUM";
}>((props) => {
  const { extraData, fromPage, size, disabled } = props;
  return (
    <Et3Button
      isEnabled={!disabled}
      onClick={async () => {
        await getTBWStore().showActionTBWPopUp({
          type: "ACTION_TBW",
          headerMessage: i18n.getWithExtraData(
            "SELECT_REASONS_OF_ACTION",
            "warning"
          ),
          actionName: "warning",
          fromPage,
          extraData,
          issueAudit: "",
          eventId: -1
        });
      }}
      text="WARN"
      type="WARN"
      size={size}
    />
  );
});
export default WarningButton;
